var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app',{attrs:{"tabbar":""}},[_c('div',{staticClass:"list"},[_c('h1',[_vm._v("操作帮助中心")]),_c('ul',_vm._l((_vm.videoList),function(item,i){return _c('li',{key:i},[_c('video',{attrs:{"src":item.video,"controls":""}}),_c('p',[_vm._v(_vm._s(item.name))])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }